import { fetchApi } from "@/helpers/fetchApi";
import { mapUnenrollmentError } from "@/helpers/unenrollmentErrors";

export const unenrollmentRequest = async <T>(path: string, init: RequestInit): Promise<T> => {
  let response: T | undefined;
  try {
    response = (await fetchApi(path, init)) as T | undefined;
  } catch (err) {
    throw mapUnenrollmentError(err);
  }
  if (response === undefined) {
    throw mapUnenrollmentError({ message: "", status: 401 });
  }
  return response;
};
